export * from './post-dokument-hinterlegen.service';
export * from './post-dokument-hinterlegen.service.module';